import { MainNavFooter, MainNavFooterItem } from '@salecycle/ui-component-library';
import { useAppContext } from 'core/app/AppContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Actions as RouterActions } from 'router';
import { Actions as AuthActions } from 'services/authentication';
import { Selectors } from 'services/authentication/ducks/selectors';
import { State } from 'store';
import * as RecentClients from '../../SearchOverlay/utils/recentClients';
import Auth from '@aws-amplify/auth';

/*
Reused code from old app footer
*/

const signOut = async (push: (location: string) => void, authSignOut: () => void) => {
  // global sign out revokes the auth token from Cognito
  await Auth.signOut({ global: true });
  RecentClients.removeFromLocalStorage();
  authSignOut();
  push('/');
};

interface StateProps {
  profileImageUrl?: string | null;
  username?: string;
}

interface DispatchProps {
  authSignOut: () => void;
  push: (location: string) => void;
}

type Props = StateProps & DispatchProps;

export const NavFooter: React.FC<Props> = ({ authSignOut, profileImageUrl, push, username }) => {
  const { setSignedIn } = useAppContext();
  const { t } = useTranslation();

  const goToProfilePage = () => {
    push('/profile');
  };

  const handleSignOutClick = () => {
    setSignedIn(false);
    signOut(push, authSignOut);
  };

  return (
    <div data-testid="AppMainNavFooter">
      <MainNavFooter
        label={username}
        menuDirection="up"
        avatarIcon={profileImageUrl ? null : 'user'}
        avatarImage={profileImageUrl ? profileImageUrl : null}
        ariaLabel="Profile and Sign Out Sub Menu"
      >
        <MainNavFooterItem data-testid="ProfileButton" onClick={goToProfilePage}>
          {t('mainnav.profile')}
        </MainNavFooterItem>
        <MainNavFooterItem data-testid="SignOutButton" onClick={handleSignOutClick}>
          {t('mainnav.signOut')}
        </MainNavFooterItem>
      </MainNavFooter>
    </div>
  );
};

const mapStateToProps = (state: State): StateProps => {
  return {
    profileImageUrl: Selectors.getPicture(state),
    username: Selectors.getUsername(state),
  };
};

const actions: DispatchProps = {
  push: RouterActions.push,
  authSignOut: AuthActions.signOut,
};

export default connect(mapStateToProps, actions)(NavFooter);
